import { useRepositoryQuery } from '@mews-commander/data-access';
import { orderOrderableEntityArray } from '@mews-commander/legacy-entities/src/utils/orderableEntities';

interface QueryParams {
    serviceId: string;
    enterpriseId: string;
}
export const useGetSpaceCategories = ({ serviceId, enterpriseId }: QueryParams) =>
    useRepositoryQuery(
        'resourceCategories',
        'getAll',
        { serviceIds: [serviceId], enterpriseId },
        {
            select: ({ resourceCategories }) =>
                resourceCategories ? orderOrderableEntityArray(resourceCategories) : undefined,
        }
    );
